import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set as setUserRoles
} from '../redux/userRoles'

export default function * fetchUserRoles (action) {
  const { userId, onEnd } = action.payload

  const state = yield select()

  const currentUserId = state.kanbo.currentUser.id

  let roles

  if (userId === currentUserId) {
    const { Roles } = yield call(apiGetData, 'MyRoles', {
      userId,
      explicitlyAssignedRolesOnly: true
    })

    roles = Roles
  } else {
    const { Roles } = yield call(apiGetData, 'UserRoles', {
      userId
    })

    roles = Roles
  }

  yield put(setUserRoles({
    userId,
    roles,
  }))

  if (onEnd) onEnd()

  return roles
}
